import React, { useState } from 'react';
import { Badge } from './badge';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';

const SKUPillInput = ({ value = [], onChange, placeholder = "Enter SKU codes...", className, error }) => {
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (e) => {
        const val = e.target.value;
        if (val.endsWith(',')) {
            const newSku = val.slice(0, -1).trim();
            if (newSku && !value.includes(newSku)) {
                onChange([...value, newSku]);
            }
            setInputValue('');
        } else {
            setInputValue(val);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const newSku = inputValue.trim();
            if (newSku && !value.includes(newSku)) {
                onChange([...value, newSku]);
            }
            setInputValue('');
        } else if (e.key === 'Backspace' && !inputValue && value.length > 0) {
            onChange(value.slice(0, -1));
        }
    };

    const removeSku = (skuToRemove) => {
        onChange(value.filter(sku => sku !== skuToRemove));
    };

    return (
        <div className={cn("space-y-2", className)}>
            <div className={cn(
                "flex flex-wrap gap-2 min-h-[42px] p-2 border rounded-xl focus-within:ring-2 focus-within:ring-indigo-500/20 bg-white border-input transition-all",
                error && "border-rose-500 ring-rose-500 bg-rose-50"
            )}>
                {value.map((sku, index) => (
                    <Badge key={index} variant="secondary" className="flex items-center gap-1 bg-sky-100 text-sky-700 hover:bg-sky-200 border-sky-200 dark:bg-sky-900/30 dark:text-sky-300 dark:border-sky-800 py-1">
                        {sku}
                        <button
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                removeSku(sku);
                            }}
                            className="hover:text-rose-600 focus:outline-none transition-colors"
                        >
                            <X className="h-3 w-3" />
                        </button>
                    </Badge>
                ))}
                <input
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    onBlur={() => {
                        const newSku = inputValue.trim();
                        if (newSku && !value.includes(newSku)) {
                            onChange([...value, newSku]);
                            setInputValue('');
                        }
                    }}
                    placeholder={value.length === 0 ? placeholder : ""}
                    className="flex-1 min-w-[120px] bg-transparent outline-none text-sm placeholder:text-muted-foreground"
                />
            </div>
            <p className="text-[10px] text-muted-foreground font-medium">
                💡 Type SKU and press <span className="font-bold text-sky-600">comma (,)</span> or <span className="font-bold text-sky-600">Enter</span> to add.
            </p>
        </div>
    );
};

export default SKUPillInput;
